<section class="quality rs-section">
  <div class="rs-container">
    <header class="quality__intro" [rsReveal]="0">
      <p class="rs-eyebrow rs-eyebrow--center">Genussregion</p>
      <h2 class="title">Pongauer Wild</h2>
      <p class="context">
        Als zertifizierter Mitgliedsbetrieb der Genussregion Pongauer Wild gibt es bei uns perfektes Wildbret
        in höchster Qualität. Dazu kommt eine Vielfalt an Wildwurstspezialitäten aus hauseigener Produktion –
        an der Theke gibt es gerne Auskunft dazu.
      </p>
      <a class="rs-btn rs-btn--ghost"
         href="http://pongauerwild.at"
         target="_blank"
         rel="noopener">Zur Genussregion Pongauer Wild</a>
    </header>

    <div class="quality__film" [rsReveal]="0">
      <video id="quality-video"
             class="quality__video"
             #qualityVideo
             autoplay
             muted
             [muted]="true"
             loop
             playsinline
             preload="metadata"
             (canplay)="muteVideo($event)">
        <source src="assets/video/quality/video.mp4" type="video/mp4">
      </video>
    </div>

    <div class="quality__awards" [rsReveal]="0">
      <p class="rs-eyebrow rs-eyebrow--center">Auszeichnungen</p>
      <h3 class="quality__awards-title">Ausgezeichnet für Herkunft und Handwerk</h3>
      <p class="quality__awards-lead">
        Preise sind uns nicht wichtiger als das tägliche Handwerk. Sie zeigen aber, dass Herkunft,
        Schlachtung und Geschmack auch von außen Bestand haben.
      </p>

      <ul class="quality__awards-grid">
        <li class="award-card">
          <span class="award-card__mark">AMA</span>
          <h4 class="award-card__title">AMA Lukullus</h4>
          <p class="award-card__text">
            Zweimal prämiert, zuletzt 2019. Für Handwerk, Herkunft und den Geschmack, der daraus entsteht.
          </p>
        </li>
        <li class="award-card">
          <span class="award-card__mark">Siegel</span>
          <h4 class="award-card__title">AMA Gütesiegel</h4>
          <p class="award-card__text">
            Geprüfte Herkunft und nachvollziehbare Qualität – vom Hof in der Umgebung bis in die Theke.
          </p>
        </li>
        <li class="award-card">
          <span class="award-card__mark">2024</span>
          <h4 class="award-card__title">Restaurant Guru</h4>
          <p class="award-card__text">
            Empfohlen als Metzgerei und Marktstubn in St. Johann im Pongau – fürs Essen und fürs Mitnehmen.
          </p>
        </li>
        <li class="award-card">
          <span class="award-card__mark">Region</span>
          <h4 class="award-card__title">Pongauer Wild</h4>
          <p class="award-card__text">
            Zertifizierter Mitgliedsbetrieb der Genussregion. Wildbret und Wildwurst aus eigener Verarbeitung.
          </p>
        </li>
      </ul>

      <img class="quality__awards-badge"
           src="assets/img/auszeichnungen/ama-siegel.png"
           alt="AMA Gütesiegel"
           loading="lazy">
    </div>

    <div class="quality__partner" [rsReveal]="80">
      <div class="quality__partner-text">
        <p class="rs-eyebrow">Herkunft</p>
        <h3 class="quality__partner-title">Salzburg schmeckt</h3>
        <p class="quality__partner-note">
          Regionale Landwirtschaft, kurze Wege und Partner, die wir persönlich kennen – das ist die Basis
          für alles, was bei uns über die Theke geht.
        </p>
      </div>
      <a class="rs-btn rs-btn--primary"
         href="http://salzburgerlandwirtschaft.at"
         target="_blank"
         rel="noopener">Mehr dazu</a>
    </div>
  </div>
</section>
